import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=72fffaaa&scoped=true"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"
import style0 from "./headline.vue?vue&type=style&index=0&id=72fffaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fffaaa",
  null
  
)

export default component.exports